import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DesignService } from 'src/app/service/design.service';

@Component({
  selector: 'app-deletedesign',
  templateUrl: './deletedesign.component.html',
  styleUrls: ['./deletedesign.component.scss']
})
export class DeletedesignComponent implements OnInit {
  data: any;
  constructor(private designService: DesignService, private dialogRef: MatDialogRef<DeletedesignComponent>, @Inject(MAT_DIALOG_DATA) data) {
    this.data = data;
    console.log(this.data)
  }


  close() {
    this.dialogRef.close();
  }

  delete() {
    this.designService.deleteDesign(this.data.id).then((data) => {
      this.close()
    }, err => {
      console.log(err)
    })
  }

  ngOnInit(): void {
  }

}
